/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as import0 from '@angular/material/input/input-container';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/change_detection/change_detection_util';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/query_list';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from './input-container.css.ngstyle';
import * as import11 from '@angular/core/src/linker/view_container';
import * as import12 from '../../common/src/directives/ng_if.ngfactory';
import * as import13 from '@angular/core/src/linker/template_ref';
import * as import14 from '@angular/common/src/directives/ng_if';
var Wrapper_MdPlaceholder = (function () {
    function Wrapper_MdPlaceholder() {
        this._changed = false;
        this.context = new import0.MdPlaceholder();
    }
    Wrapper_MdPlaceholder.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdPlaceholder.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdPlaceholder.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdPlaceholder.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_MdPlaceholder.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdPlaceholder.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdPlaceholder;
}());
export { Wrapper_MdPlaceholder };
var Wrapper_MdInputContainer = (function () {
    function Wrapper_MdInputContainer() {
        this._changed = false;
        this.context = new import0.MdInputContainer();
        this._expr_0 = import2.UNINITIALIZED;
        this._expr_1 = import2.UNINITIALIZED;
        this._expr_2 = import2.UNINITIALIZED;
        this._expr_3 = import2.UNINITIALIZED;
        this._expr_4 = import2.UNINITIALIZED;
        this._expr_5 = import2.UNINITIALIZED;
        this._expr_6 = import2.UNINITIALIZED;
        this._expr_7 = import2.UNINITIALIZED;
        this._expr_8 = import2.UNINITIALIZED;
        this._expr_9 = import2.UNINITIALIZED;
        this._expr_10 = import2.UNINITIALIZED;
        this._expr_11 = import2.UNINITIALIZED;
        this._expr_12 = import2.UNINITIALIZED;
    }
    Wrapper_MdInputContainer.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdInputContainer.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdInputContainer.prototype.check_align = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.align = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_MdInputContainer.prototype.check_dividerColor = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this._changed = true;
            this.context.dividerColor = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_MdInputContainer.prototype.check_hintLabel = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this._changed = true;
            this.context.hintLabel = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_MdInputContainer.prototype.check_floatPlaceholder = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this._changed = true;
            this.context.floatPlaceholder = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_MdInputContainer.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdInputContainer.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_4 = true;
        if (import3.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            view.renderer.setElementClass(el, 'mat-input-container', currVal_4);
            this._expr_4 = currVal_4;
        }
        var currVal_5 = null;
        if (import3.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            view.renderer.setElementAttribute(el, 'align', ((currVal_5 == null) ? null : currVal_5.toString()));
            this._expr_5 = currVal_5;
        }
        var currVal_6 = this.context._shouldForward('untouched');
        if (import3.checkBinding(throwOnChange, this._expr_6, currVal_6)) {
            view.renderer.setElementClass(el, 'ng-untouched', currVal_6);
            this._expr_6 = currVal_6;
        }
        var currVal_7 = this.context._shouldForward('touched');
        if (import3.checkBinding(throwOnChange, this._expr_7, currVal_7)) {
            view.renderer.setElementClass(el, 'ng-touched', currVal_7);
            this._expr_7 = currVal_7;
        }
        var currVal_8 = this.context._shouldForward('pristine');
        if (import3.checkBinding(throwOnChange, this._expr_8, currVal_8)) {
            view.renderer.setElementClass(el, 'ng-pristine', currVal_8);
            this._expr_8 = currVal_8;
        }
        var currVal_9 = this.context._shouldForward('dirty');
        if (import3.checkBinding(throwOnChange, this._expr_9, currVal_9)) {
            view.renderer.setElementClass(el, 'ng-dirty', currVal_9);
            this._expr_9 = currVal_9;
        }
        var currVal_10 = this.context._shouldForward('valid');
        if (import3.checkBinding(throwOnChange, this._expr_10, currVal_10)) {
            view.renderer.setElementClass(el, 'ng-valid', currVal_10);
            this._expr_10 = currVal_10;
        }
        var currVal_11 = this.context._shouldForward('invalid');
        if (import3.checkBinding(throwOnChange, this._expr_11, currVal_11)) {
            view.renderer.setElementClass(el, 'ng-invalid', currVal_11);
            this._expr_11 = currVal_11;
        }
        var currVal_12 = this.context._shouldForward('pending');
        if (import3.checkBinding(throwOnChange, this._expr_12, currVal_12)) {
            view.renderer.setElementClass(el, 'ng-pending', currVal_12);
            this._expr_12 = currVal_12;
        }
    };
    Wrapper_MdInputContainer.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        if ((eventName == 'click')) {
            var pd_sub_0 = (this.context._focusInput() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    Wrapper_MdInputContainer.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdInputContainer;
}());
export { Wrapper_MdInputContainer };
var Wrapper_MdHint = (function () {
    function Wrapper_MdHint() {
        this._changed = false;
        this.context = new import0.MdHint();
        this._expr_0 = import2.UNINITIALIZED;
        this._expr_1 = import2.UNINITIALIZED;
        this._expr_2 = import2.UNINITIALIZED;
        this._expr_3 = import2.UNINITIALIZED;
        this._expr_4 = import2.UNINITIALIZED;
    }
    Wrapper_MdHint.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdHint.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdHint.prototype.check_align = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.align = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_MdHint.prototype.check_id = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this._changed = true;
            this.context.id = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_MdHint.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdHint.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_2 = true;
        if (import3.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            view.renderer.setElementClass(el, 'mat-hint', currVal_2);
            this._expr_2 = currVal_2;
        }
        var currVal_3 = (this.context.align == 'end');
        if (import3.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            view.renderer.setElementClass(el, 'mat-right', currVal_3);
            this._expr_3 = currVal_3;
        }
        var currVal_4 = this.context.id;
        if (import3.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            view.renderer.setElementAttribute(el, 'id', ((currVal_4 == null) ? null : currVal_4.toString()));
            this._expr_4 = currVal_4;
        }
    };
    Wrapper_MdHint.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdHint.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdHint;
}());
export { Wrapper_MdHint };
var Wrapper_MdInputDirective = (function () {
    function Wrapper_MdInputDirective(p0, p1, p2) {
        this._changed = false;
        this.context = new import0.MdInputDirective(p0, p1, p2);
        this._expr_0 = import2.UNINITIALIZED;
        this._expr_1 = import2.UNINITIALIZED;
        this._expr_2 = import2.UNINITIALIZED;
        this._expr_3 = import2.UNINITIALIZED;
        this._expr_4 = import2.UNINITIALIZED;
        this._expr_5 = import2.UNINITIALIZED;
        this._expr_6 = import2.UNINITIALIZED;
        this._expr_7 = import2.UNINITIALIZED;
        this._expr_8 = import2.UNINITIALIZED;
        this._expr_9 = import2.UNINITIALIZED;
        this._expr_10 = import2.UNINITIALIZED;
    }
    Wrapper_MdInputDirective.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdInputDirective.prototype.ngOnDestroy = function () {
        (this.subscription0 && this.subscription0.unsubscribe());
    };
    Wrapper_MdInputDirective.prototype.check_disabled = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.disabled = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_MdInputDirective.prototype.check_id = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this._changed = true;
            this.context.id = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_MdInputDirective.prototype.check_placeholder = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this._changed = true;
            this.context.placeholder = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_MdInputDirective.prototype.check_required = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this._changed = true;
            this.context.required = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_MdInputDirective.prototype.check_type = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this._changed = true;
            this.context.type = currValue;
            this._expr_4 = currValue;
        }
    };
    Wrapper_MdInputDirective.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdInputDirective.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_5 = true;
        if (import3.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            view.renderer.setElementClass(el, 'mat-input-element', currVal_5);
            this._expr_5 = currVal_5;
        }
        var currVal_6 = this.context.id;
        if (import3.checkBinding(throwOnChange, this._expr_6, currVal_6)) {
            view.renderer.setElementProperty(el, 'id', currVal_6);
            this._expr_6 = currVal_6;
        }
        var currVal_7 = this.context.placeholder;
        if (import3.checkBinding(throwOnChange, this._expr_7, currVal_7)) {
            view.renderer.setElementProperty(el, 'placeholder', currVal_7);
            this._expr_7 = currVal_7;
        }
        var currVal_8 = this.context.disabled;
        if (import3.checkBinding(throwOnChange, this._expr_8, currVal_8)) {
            view.renderer.setElementProperty(el, 'disabled', currVal_8);
            this._expr_8 = currVal_8;
        }
        var currVal_9 = this.context.required;
        if (import3.checkBinding(throwOnChange, this._expr_9, currVal_9)) {
            view.renderer.setElementProperty(el, 'required', currVal_9);
            this._expr_9 = currVal_9;
        }
        var currVal_10 = this.context.ariaDescribedby;
        if (import3.checkBinding(throwOnChange, this._expr_10, currVal_10)) {
            view.renderer.setElementAttribute(el, 'aria-describedby', ((currVal_10 == null) ? null : currVal_10.toString()));
            this._expr_10 = currVal_10;
        }
    };
    Wrapper_MdInputDirective.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        if ((eventName == 'blur')) {
            var pd_sub_0 = (this.context._onBlur() !== false);
            result = (pd_sub_0 && result);
        }
        if ((eventName == 'focus')) {
            var pd_sub_1 = (this.context._onFocus() !== false);
            result = (pd_sub_1 && result);
        }
        if ((eventName == 'input')) {
            var pd_sub_2 = (this.context._onInput() !== false);
            result = (pd_sub_2 && result);
        }
        return result;
    };
    Wrapper_MdInputDirective.prototype.subscribe = function (view, _eventHandler, emit0) {
        this._eventHandler = _eventHandler;
        if (emit0) {
            (this.subscription0 = this.context._placeholderChange.subscribe(_eventHandler.bind(view, '_placeholderChange')));
        }
    };
    return Wrapper_MdInputDirective;
}());
export { Wrapper_MdInputDirective };
var renderType_MdInputContainer_Host = import3.createRenderComponentType('', 0, import5.ViewEncapsulation.None, [], {});
var View_MdInputContainer_Host0 = (function (_super) {
    __extends(View_MdInputContainer_Host0, _super);
    function View_MdInputContainer_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_MdInputContainer_Host0, renderType_MdInputContainer_Host, import7.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_MdInputContainer_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'md-input-container', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_MdInputContainer0(this.viewUtils, this, 0, this._el_0);
        this._MdInputContainer_0_3 = new Wrapper_MdInputContainer();
        this._query_MdInputDirective_0_0 = new import6.QueryList();
        this._query_MdPlaceholder_0_1 = new import6.QueryList();
        this._query_MdHint_0_2 = new import6.QueryList();
        this.compView_0.create(this._MdInputContainer_0_3.context);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_0, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_0));
        this._query_MdInputDirective_0_0.reset([]);
        this._MdInputContainer_0_3.context._mdInputChild = this._query_MdInputDirective_0_0.first;
        this._query_MdPlaceholder_0_1.reset([]);
        this._MdInputContainer_0_3.context._placeholderChild = this._query_MdPlaceholder_0_1.first;
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), [disposable_0]);
        return new import9.ComponentRef_(0, this, this._el_0, this._MdInputContainer_0_3.context);
    };
    View_MdInputContainer_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.MdInputContainer) && (0 === requestNodeIndex))) {
            return this._MdInputContainer_0_3.context;
        }
        return notFoundResult;
    };
    View_MdInputContainer_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._MdInputContainer_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        if (!throwOnChange) {
            if (this._query_MdHint_0_2.dirty) {
                this._query_MdHint_0_2.reset([]);
                this._MdInputContainer_0_3.context._hintChildren = this._query_MdHint_0_2;
                this._query_MdHint_0_2.notifyOnChanges();
            }
            if ((this.numberOfChecks === 0)) {
                this._MdInputContainer_0_3.context.ngAfterContentInit();
            }
        }
        this._MdInputContainer_0_3.checkHost(this, this.compView_0, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_MdInputContainer_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_MdInputContainer_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_MdInputContainer_Host0.prototype.visitProjectableNodesInternal = function (nodeIndex, ngContentIndex, cb, ctx) {
        if (((nodeIndex == 0) && (ngContentIndex == 0))) { }
        if (((nodeIndex == 0) && (ngContentIndex == 1))) { }
        if (((nodeIndex == 0) && (ngContentIndex == 2))) { }
        if (((nodeIndex == 0) && (ngContentIndex == 3))) { }
        if (((nodeIndex == 0) && (ngContentIndex == 4))) { }
    };
    View_MdInputContainer_Host0.prototype.handleEvent_0 = function (eventName, $event) {
        this.compView_0.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._MdInputContainer_0_3.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_MdInputContainer_Host0;
}(import1.AppView));
export var MdInputContainerNgFactory = new import9.ComponentFactory('md-input-container, mat-input-container', View_MdInputContainer_Host0, import0.MdInputContainer);
var styles_MdInputContainer = [import10.styles];
var View_MdInputContainer2 = (function (_super) {
    __extends(View_MdInputContainer2, _super);
    function View_MdInputContainer2(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        return _super.call(this, View_MdInputContainer2, renderType_MdInputContainer, import7.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways, declaredViewContainer) || this;
    }
    View_MdInputContainer2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'span', new import3.InlineArray2(2, 'class', 'mat-placeholder-required'), null);
        this._text_1 = this.renderer.createText(this._el_0, '*', null);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1
        ]), null);
        return null;
    };
    View_MdInputContainer2.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_MdInputContainer2;
}(import1.AppView));
var View_MdInputContainer1 = (function (_super) {
    __extends(View_MdInputContainer1, _super);
    function View_MdInputContainer1(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        var _this = _super.call(this, View_MdInputContainer1, renderType_MdInputContainer, import7.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways, declaredViewContainer) || this;
        _this._expr_6 = import2.UNINITIALIZED;
        _this._expr_7 = import2.UNINITIALIZED;
        _this._expr_8 = import2.UNINITIALIZED;
        _this._expr_9 = import2.UNINITIALIZED;
        _this._expr_10 = import2.UNINITIALIZED;
        _this._expr_11 = import2.UNINITIALIZED;
        _this._expr_12 = import2.UNINITIALIZED;
        return _this;
    }
    View_MdInputContainer1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'label', new import3.InlineArray2(2, 'class', 'mat-input-placeholder'), null);
        this.projectNodes(this._el_0, 2);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._vc_2 = new import11.ViewContainer(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import13.TemplateRef_(this, 2, this._anchor_2);
        this._NgIf_2_6 = new import12.Wrapper_NgIf(this._vc_2.vcRef, this._TemplateRef_2_5);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._anchor_2
        ]), null);
        return null;
    };
    View_MdInputContainer1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import13.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import14.NgIf) && (2 === requestNodeIndex))) {
            return this._NgIf_2_6.context;
        }
        return notFoundResult;
    };
    View_MdInputContainer1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this.parentView.context._mdInputChild.required;
        this._NgIf_2_6.check_ngIf(currVal_2_0_0, throwOnChange, false);
        this._NgIf_2_6.ngDoCheck(this, this._anchor_2, throwOnChange);
        this._vc_2.detectChangesInNestedViews(throwOnChange);
        var currVal_6 = this.parentView.context._mdInputChild.id;
        if (import3.checkBinding(throwOnChange, this._expr_6, currVal_6)) {
            this.renderer.setElementAttribute(this._el_0, 'for', ((currVal_6 == null) ? null : currVal_6.toString()));
            this._expr_6 = currVal_6;
        }
        var currVal_7 = (this.parentView.context._mdInputChild.empty && !this.parentView.context._shouldAlwaysFloat);
        if (import3.checkBinding(throwOnChange, this._expr_7, currVal_7)) {
            this.renderer.setElementClass(this._el_0, 'mat-empty', currVal_7);
            this._expr_7 = currVal_7;
        }
        var currVal_8 = this.parentView.context._mdInputChild.focused;
        if (import3.checkBinding(throwOnChange, this._expr_8, currVal_8)) {
            this.renderer.setElementClass(this._el_0, 'mat-focused', currVal_8);
            this._expr_8 = currVal_8;
        }
        var currVal_9 = this.parentView.context._canPlaceholderFloat;
        if (import3.checkBinding(throwOnChange, this._expr_9, currVal_9)) {
            this.renderer.setElementClass(this._el_0, 'mat-float', currVal_9);
            this._expr_9 = currVal_9;
        }
        var currVal_10 = (this.parentView.context.dividerColor == 'accent');
        if (import3.checkBinding(throwOnChange, this._expr_10, currVal_10)) {
            this.renderer.setElementClass(this._el_0, 'mat-accent', currVal_10);
            this._expr_10 = currVal_10;
        }
        var currVal_11 = (this.parentView.context.dividerColor == 'warn');
        if (import3.checkBinding(throwOnChange, this._expr_11, currVal_11)) {
            this.renderer.setElementClass(this._el_0, 'mat-warn', currVal_11);
            this._expr_11 = currVal_11;
        }
        var currVal_12 = import3.inlineInterpolate(1, '', this.parentView.context._mdInputChild.placeholder, ' ');
        if (import3.checkBinding(throwOnChange, this._expr_12, currVal_12)) {
            this.renderer.setText(this._text_1, currVal_12);
            this._expr_12 = currVal_12;
        }
    };
    View_MdInputContainer1.prototype.destroyInternal = function () {
        this._vc_2.destroyNestedViews();
    };
    View_MdInputContainer1.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_MdInputContainer1.prototype.createEmbeddedViewInternal = function (nodeIndex) {
        if ((nodeIndex == 2)) {
            return new View_MdInputContainer2(this.viewUtils, this, 2, this._anchor_2, this._vc_2);
        }
        return null;
    };
    return View_MdInputContainer1;
}(import1.AppView));
var View_MdInputContainer3 = (function (_super) {
    __extends(View_MdInputContainer3, _super);
    function View_MdInputContainer3(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        var _this = _super.call(this, View_MdInputContainer3, renderType_MdInputContainer, import7.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways, declaredViewContainer) || this;
        _this._expr_2 = import2.UNINITIALIZED;
        _this._expr_3 = import2.UNINITIALIZED;
        return _this;
    }
    View_MdInputContainer3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'div', new import3.InlineArray2(2, 'class', 'mat-hint'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1
        ]), null);
        return null;
    };
    View_MdInputContainer3.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2 = this.parentView.context._hintLabelId;
        if (import3.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementAttribute(this._el_0, 'id', ((currVal_2 == null) ? null : currVal_2.toString()));
            this._expr_2 = currVal_2;
        }
        var currVal_3 = import3.inlineInterpolate(1, '', this.parentView.context.hintLabel, '');
        if (import3.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            this.renderer.setText(this._text_1, currVal_3);
            this._expr_3 = currVal_3;
        }
    };
    View_MdInputContainer3.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_MdInputContainer3;
}(import1.AppView));
var renderType_MdInputContainer = import3.createRenderComponentType('', 5, import5.ViewEncapsulation.None, styles_MdInputContainer, {});
var View_MdInputContainer0 = (function (_super) {
    __extends(View_MdInputContainer0, _super);
    function View_MdInputContainer0(viewUtils, parentView, parentIndex, parentElement) {
        var _this = _super.call(this, View_MdInputContainer0, renderType_MdInputContainer, import7.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways) || this;
        _this._expr_16 = import2.UNINITIALIZED;
        _this._expr_17 = import2.UNINITIALIZED;
        _this._expr_18 = import2.UNINITIALIZED;
        _this._expr_19 = import2.UNINITIALIZED;
        _this._expr_20 = import2.UNINITIALIZED;
        return _this;
    }
    View_MdInputContainer0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import3.createRenderElement(this.renderer, parentRenderNode, 'div', new import3.InlineArray2(2, 'class', 'mat-input-wrapper'), null);
        this._el_1 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'class', 'mat-input-table'), null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'mat-input-prefix'), null);
        this.projectNodes(this._el_2, 0);
        this._el_3 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'mat-input-infix'), null);
        this.projectNodes(this._el_3, 1);
        this._el_4 = import3.createRenderElement(this.renderer, this._el_3, 'span', new import3.InlineArray2(2, 'class', 'mat-input-placeholder-wrapper'), null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_4, null);
        this._vc_5 = new import11.ViewContainer(5, 4, this, this._anchor_5);
        this._TemplateRef_5_5 = new import13.TemplateRef_(this, 5, this._anchor_5);
        this._NgIf_5_6 = new import12.Wrapper_NgIf(this._vc_5.vcRef, this._TemplateRef_5_5);
        this._el_6 = import3.createRenderElement(this.renderer, this._el_1, 'div', new import3.InlineArray2(2, 'class', 'mat-input-suffix'), null);
        this.projectNodes(this._el_6, 3);
        this._el_7 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'class', 'mat-input-underline'), null);
        this._el_8 = import3.createRenderElement(this.renderer, this._el_7, 'span', new import3.InlineArray2(2, 'class', 'mat-input-ripple'), null);
        this._anchor_9 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._vc_9 = new import11.ViewContainer(9, 0, this, this._anchor_9);
        this._TemplateRef_9_5 = new import13.TemplateRef_(this, 9, this._anchor_9);
        this._NgIf_9_6 = new import12.Wrapper_NgIf(this._vc_9.vcRef, this._TemplateRef_9_5);
        this.projectNodes(this._el_0, 4);
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._el_1,
            this._el_2,
            this._el_3,
            this._el_4,
            this._anchor_5,
            this._el_6,
            this._el_7,
            this._el_8,
            this._anchor_9
        ]), null);
        return null;
    };
    View_MdInputContainer0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import13.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import14.NgIf) && (5 === requestNodeIndex))) {
            return this._NgIf_5_6.context;
        }
        if (((token === import13.TemplateRef) && (9 === requestNodeIndex))) {
            return this._TemplateRef_9_5;
        }
        if (((token === import14.NgIf) && (9 === requestNodeIndex))) {
            return this._NgIf_9_6.context;
        }
        return notFoundResult;
    };
    View_MdInputContainer0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_5_0_0 = this.context._hasPlaceholder();
        this._NgIf_5_6.check_ngIf(currVal_5_0_0, throwOnChange, false);
        this._NgIf_5_6.ngDoCheck(this, this._anchor_5, throwOnChange);
        var currVal_9_0_0 = (this.context.hintLabel != '');
        this._NgIf_9_6.check_ngIf(currVal_9_0_0, throwOnChange, false);
        this._NgIf_9_6.ngDoCheck(this, this._anchor_9, throwOnChange);
        this._vc_5.detectChangesInNestedViews(throwOnChange);
        this._vc_9.detectChangesInNestedViews(throwOnChange);
        var currVal_16 = (this.context.align == 'end');
        if (import3.checkBinding(throwOnChange, this._expr_16, currVal_16)) {
            this.renderer.setElementClass(this._el_3, 'mat-end', currVal_16);
            this._expr_16 = currVal_16;
        }
        var currVal_17 = this.context._mdInputChild.disabled;
        if (import3.checkBinding(throwOnChange, this._expr_17, currVal_17)) {
            this.renderer.setElementClass(this._el_7, 'mat-disabled', currVal_17);
            this._expr_17 = currVal_17;
        }
        var currVal_18 = this.context._mdInputChild.focused;
        if (import3.checkBinding(throwOnChange, this._expr_18, currVal_18)) {
            this.renderer.setElementClass(this._el_8, 'mat-focused', currVal_18);
            this._expr_18 = currVal_18;
        }
        var currVal_19 = (this.context.dividerColor == 'accent');
        if (import3.checkBinding(throwOnChange, this._expr_19, currVal_19)) {
            this.renderer.setElementClass(this._el_8, 'mat-accent', currVal_19);
            this._expr_19 = currVal_19;
        }
        var currVal_20 = (this.context.dividerColor == 'warn');
        if (import3.checkBinding(throwOnChange, this._expr_20, currVal_20)) {
            this.renderer.setElementClass(this._el_8, 'mat-warn', currVal_20);
            this._expr_20 = currVal_20;
        }
    };
    View_MdInputContainer0.prototype.destroyInternal = function () {
        this._vc_5.destroyNestedViews();
        this._vc_9.destroyNestedViews();
    };
    View_MdInputContainer0.prototype.createEmbeddedViewInternal = function (nodeIndex) {
        if ((nodeIndex == 5)) {
            return new View_MdInputContainer1(this.viewUtils, this, 5, this._anchor_5, this._vc_5);
        }
        if ((nodeIndex == 9)) {
            return new View_MdInputContainer3(this.viewUtils, this, 9, this._anchor_9, this._vc_9);
        }
        return null;
    };
    return View_MdInputContainer0;
}(import1.AppView));
export { View_MdInputContainer0 };
//# sourceMappingURL=input-container.ngfactory.js.map